import { marketStudiesActions } from '../../store/marketStudies/actions';

import { useAppDispatch, useAppSelector } from '../../App/redux/store';
import ActionModal from '../../features/modals/components/actionModal/ActionModal';
import { getModalsState, modalsActions } from '../../features/modals/modalsSlice';
import './marketStudyDeleteModal.scss';

const MarketStudyDeleteModal = () => {
  const { deleteMarketStudy } = useAppSelector(getModalsState);

  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(modalsActions.deleteMarketStudy(null));
  };
  return (
    <ActionModal
      closeAction={handleClose}
      validAction={marketStudiesActions.deleteMarketStudy.request(
        deleteMarketStudy.idIri,
      )}
      validText="SUPPRIMER"
      modalType="suppression"
    >
      <p>
        Confirmez-vous la suppression de l&apos;étude de marché
        <span>{` ${deleteMarketStudy.name} `}</span>?
      </p>
      <p>La suppression sera définitive.</p>
    </ActionModal>
  );
};

export default MarketStudyDeleteModal;
